import { getStorage, ref as storageRef, deleteObject } from 'firebase/storage';

/**
 * Deletes all files in Firebase Storage for a given configId and user.
 * @param {string} uid - User ID
 * @param {string} configId - Config ID
 * @param {object} configData - The config object from DB (should include stdFiles, qcFiles, unkFiles)
 */
export async function deleteConfigFilesFromStorage(uid, configId, configData) {
  if (!uid || !configId || !configData) return;
  const storage = getStorage();
  const fileTypes = ['stdFiles', 'qcFiles', 'unkFiles'];
  const deletePromises = [];

  for (const fileType of fileTypes) {
    const filesObj = configData[fileType];
    if (!filesObj || typeof filesObj !== 'object') continue;
    for (const [fileName, fileObj] of Object.entries(filesObj)) {
      // Delete each array URL if present
      ['originalDataUrl', 'originalXValuesUrl', 'originalYValuesUrl'].forEach(field => {
        const url = fileObj[field];
        if (url) {
          // Convert download URL to storage path
          const pathMatch = url.match(/\/o\/(.+)\?/);
          let storagePath;
          if (pathMatch && pathMatch[1]) {
            storagePath = decodeURIComponent(pathMatch[1]);
          } else {
            // Fallback: reconstruct path
            storagePath = `users/${uid}/results/${configId}/${fileType}/${fileName}/${field.replace('Url', '')}.json`;
          }
          const fileRef = storageRef(storage, storagePath);
          deletePromises.push(deleteObject(fileRef));
        }
      });
    }
  }
  await Promise.allSettled(deletePromises);
}
